<template>
    <v-container class="c-claims app-bg">
        <v-layout column >
            <p style="line-height:27px">
                <span style="font-size:16px; ">&nbsp;</span>
            </p>
            <p style="text-align:center;line-height:27px">
                <strong><span style="font-size:19px; ">关于防范新型电信网络诈骗的风险提示</span></strong>            
            </p>
            <p style="line-height:27px">
                <span style="font-size:16px; ">&nbsp;</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">近年来，随着网络技术的发展，诈骗手段快速翻新，迷惑性不断增强，严重侵害公众财产安全与合法权益。为此，国家金融监督管理总局金融消费者权益保护局发布防范新型电信网络诈骗风险提示，提醒广大群众警惕花样翻新的骗局，增强风险防范意识和识别能力，守护好自己的钱袋子。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size: 16px; ">新型电信网络诈骗主要有以下几类：</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">一、“共享屏幕”类诈骗。不法分子以“提升信用卡额度”“取消名下不实贷款”“注销保险服务”“航班延误退费”“赠送礼品”等为借口，向个人发送短信或拨打电话，诱导消费者下载指定的聊天软件、网络视频会议软件，并让个人开启软件的“共享屏幕”功能，以便不法分子“实时监控”消费者手机、电脑屏幕，“指导”消费者进行银行卡绑定、密码修改等操作，同步获取个人银行账户、密码、验证码等重要信息，从而盗取银行卡资金。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">二、“AI换脸拟声”类诈骗。不法分子以“网店客服”“营销推广”“招聘兼职”“婚恋交友”等为借口，通过微信、电话等方式联系消费者，采集发音、语句或面部信息。利用“换脸”“拟声”等技术合成消费者虚假音频、视频或图像，模拟他人声音或形象骗取信任，以借钱、投资、紧急救助等借口诱导其亲友转账汇款，或提供银行账户密码等敏感信息，随后立即转移资金。此外，不法分子还可能对明星、专家、执法人员等音视频进行人工合成，假借其身份传播虚假消息，从而实现诈骗目的。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">三、虚假网络投资理财类诈骗。不法分子假借债券投资、股票投资、贵金属投资、期货投资等概念，在网络平台发布消息宣称“稳赚不赔”，吸引群众关注。并将个人拉入“投资”群聊，然后冒充投资导师、理财专家，以“专家内幕”虚假消息诱导投资，或通过婚恋交友平台与个人确定婚恋关系，再以有“内部消息”“特殊资源”等诱骗个人参与投资，引导个人在伪造或仿冒的投资平台进行投资，并以小额投资返利作为诱饵，不断引导个人加大资金投入，随后迅速转移资金。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">四、网络游戏产品虚假交易类诈骗。不法分子在网络游戏或社交平台中发布虚假的游戏账号、装备、点卡买卖信息，以“低价出售”“高价收购”为噱头，吸引游戏玩家关注。对想低价购买游戏产品的玩家，不法分子诱导其绕过正规游戏交易平台与其进行线下交易，当玩家支付钱款后，不法分子便消失无踪；对想高价出售游戏产品的玩家，不法分子诱骗其登录虚假交易网站进行交易，并以各种理由要求玩家先缴纳保证金、手续费等费用才可“提现”，并不断要求玩家充值更多金额，随后迅速转移资金。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">诈骗形式不断演变翻新，伪装性越来越强，群众稍有不慎便遭受经济损失。为保护广大群众合法权益，强化反诈意识、提升反诈能力，国家金融监督管理总局金融消费者权益保护局提示广大群众：</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">一、不盲目不轻信，不贪小利防骗局。树立科学理性的投资理财观念，提高风险防范意识和信息甄别能力，对退还费用、礼品赠送、保本高息、高价收购等“天上掉馅饼”的说辞保持警惕，避免贪图小便宜，遭受大损失。避免盲目跟风或投机心理，不轻信来路不明“小道消息”，不轻信“稳赚不赔”或“保本高收益”等说辞。在选择理财产品时，应选择正规金融机构并仔细阅读合同条款，充分评估自身的风险承受能力，选择符合自身需求的产品，提升识骗防骗能力，谨防财产遭受损失。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">二、拒绝“共享屏幕”，保护信息防泄露。增强个人信息保护意识，妥善保管身份证号、银行卡号、账户密码、验证码、个人生物识别等信息。不随意点击不明链接，不随意下载陌生软件、注册陌生平台或添加陌生好友，对个人社交账户的安全状况保持警惕，拒绝陌生人“共享屏幕”要求，避免无关人员操纵本人手机、电脑等电子设备，避免因个人信息泄露造成经济损失。同时，应加强对个人信息的保护措施，定期检查账户安全设置，及时发现并处理异常情况。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">三、转账汇款严把关，谨慎操作护财产。涉及转账、汇款操作时要提高警惕，防范资金被骗风险。在接到涉及要求转账汇款的电话、短信或网络信息时，及时通过官方机构核实信息的真实性，不轻信陌生人的转账要求或诱导信息，不贸然向陌生人提供的账号转账汇款，不随意向无关账户转账打款。在转账汇款前，务必认真核对对方身份和信息，确保资金是转给真正可信任的人员或机构。</span>
            </p>
            <p style="text-indent:32px;line-height:27px">
                <span style="font-size:16px; ">四、正规渠道保权益，遭遇诈骗速报警。群众如遇经济纠纷，应依法通过正规渠道进行维权，可通过第三方调解组织进行调解、向司法机关提起诉讼。如发现自己陷入诈骗陷阱导致资金受损，或发现涉嫌违法犯罪线索，应保存好聊天记录、通话录音、交易截屏等有关证据，及时向公安机关反映。同时，不可轻信网络上自称“网警”“黑客”等组织或人员，避免再次受骗。</span>
            </p>
            <p style="line-height:27px;text-align:right">
                <span style="font-size:16px; ">文章来源：国家金融监督管理总局网站</span>
            </p>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "1008"
    }
</script>

<style scoped>

</style>
